// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__17tVm","inner":"Footer_inner__YiArG"};